// §6.4 — the closed set of shell actions a keymap may bind to.
//
// A binding names an action; the kernel owns what the action does. That is what lets the three
// keymaps differ completely (§6.4's table) while the behavior stays in one place, and what
// makes a per-binding override in Settings → Keyboard (§11.6) a data change.

export const SHELL_ACTIONS = [
  'launcher.open',
  'switcher.windows',
  'switcher.overview',
  'window.close',
  'window.snapLeft',
  'window.snapRight',
  'window.snapUp',
  'window.snapDown',
  'desktop.previous',
  'desktop.next',
  'clipboard.history',
  'notifications.center',
  'shell.immersive',
  'shell.lock',
  'app.explorer',
  'app.settings',
  /**
   * §34.4 — Quick Notes' capture card.
   *
   * The first action in this set an *app* owns rather than the shell (D-059): the shell arbitrates
   * the key, and Quick Notes arms it. It is in the closed set for the reason everything else here
   * is — it must be `reserved`, so a focused game or an external app's iframe forwards it instead of
   * swallowing it (§9.7), and only a named action can be.
   */
  'notes.capture',
] as const;

export type ShellAction = (typeof SHELL_ACTIONS)[number];

export function isShellAction(value: string): value is ShellAction {
  return (SHELL_ACTIONS as readonly string[]).includes(value);
}
